import store from '@speechki-frontend/core/store/store';
import { customerStore } from './customers/store';
import { customersMemberStore } from './customers/store';
import { employeeStore } from './employees/store';
import { orderStore } from './orders/store';
import { usersStore } from './users/store';
import { workspaces } from './workspaces/store';

store.registerModule('customer', customerStore);
store.registerModule('customersMember', customersMemberStore);
store.registerModule('employee', employeeStore);
store.registerModule('order', orderStore);
store.registerModule('users', usersStore);
store.registerModule('workspaces', workspaces);

export default store;
